export const actionTypes = {
  SET_ALLERGIES_IS_LOADING: 'MEMBER_PORTAL/SET_ALLERGIES_IS_LOADING',
  FETCH_ALLERGIES: 'MEMBER_PORTAL/FETCH_ALLERGIES',
  UPDATE_ALLERGIES: 'MEMBER_PORTAL/UPDATE_ALLERGIES',
  RESET_ALLERGIES: 'MEMBER_PORTAL/RESET_ALLERGIES',
};
